import serverFetch from '../utils/serverFetch'

export async function fetch_all_services_admin() {
  return serverFetch({
    method: 'GET',
    endpoint: '/services/admin'
  })
}

export async function create_new_service(serviceData) {
  return serverFetch({
    method: 'POST',
    endpoint: '/services/',
    body: JSON.stringify(serviceData),
  })
}

export async function update_service(service_id, serviceData) {
  return serverFetch({
    method: 'PUT',
    endpoint: `/services/id/${service_id}`,
    body: JSON.stringify(serviceData),
  })
}

export async function delete_service(service_id) {
  return serverFetch({
    method: 'DELETE',
    endpoint: `/services/id/${service_id}`
  })
}

export async function get_service_by_id(service_id) {
  return serverFetch({
    method: 'GET',
    endpoint: `/services/id/${service_id}`
  })
}

export async function duplicate_service(serviceData) {
  return serverFetch({
    method: 'POST',
    endpoint: '/services/duplicate',
    body: JSON.stringify(serviceData),
  })
}

export async function get_past_services() {
  return serverFetch({
    method: 'GET',
    endpoint: '/services/past'
  })
}

export async function get_all_services() {
  return serverFetch({
    method: 'GET',
    endpoint: '/services/all'
  })
}

export async function get_special_ongoing_services() {
  return serverFetch({
    method: 'GET',
    endpoint: '/services/special'
  })
}

export async function fetch_all_special_services_admin() {
  return serverFetch({
    method: 'GET',
    endpoint: '/services/special/admin'
  })
}

export async function create_new_special_service(specialServiceData) {
  return serverFetch({
    method: 'POST',
    endpoint: '/services/special',
    body: JSON.stringify(specialServiceData)
  })
}

export async function update_special_service(special_service_id, specialServiceData) {
  return serverFetch({
    method: 'PUT',
    endpoint: `/services/special/id/${special_service_id}`,
    body: JSON.stringify(specialServiceData)
  })
}

export async function delete_special_service(special_service_id) {
  return serverFetch({
    method: 'DELETE',
    endpoint: `/services/special/id/${special_service_id}`
  })
}

export async function get_special_service_by_id(special_service_id) {
  return serverFetch({
    method: 'GET',
    endpoint: `/services/special/id/${special_service_id}`
  })
}
